module.exports = __webpack_public_path__ + "img/icon-camera.794705ca.svg";